module.exports = __webpack_public_path__ + "img/2.1cf87535.jpg";